import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, PropType, watch } from "vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import LookupMultiSelect from "@/components/ui/lookup/lookup-multi-select.vue";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import GridFiltersBase from "@/components/ui/grid/grid-filters-base.vue";
import { SignableListFilters } from "@/types/signable-documents/SignableListFilters";
import { ReminderFilters } from "@/types/reminders/ReminderFilters";


export default /*#__PURE__*/_defineComponent({
  __name: 'signable-documents-filter-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The filters from the reminders page are passed to the modal to be the default filters.
   * @type {object}
   * @required
   */
  reminderPageFilters: {
    type: Object as PropType<ReminderFilters>,
    required: true,
  },
  /**
   * The title of signable modal.
   * @type {object}
   * @required
   */
  modalTitle: {
    type: String,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  /** Triggered when filters are applied from the grid filters base.
    @event filtersApplied @property {CertificateListFilters} filters - The applied filters from the modal. */
  "filtersApplied",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

/** Handles the filters applied event from the grid filters base */
const onFiltersApplied = () => emit("filtersApplied", modalFilter.value);

/** Handles the clear filters event from the grid filters base */
const onClearFilters = () => {
  modalFilter.value.branches = [];
  modalFilter.value.users = [];
};

const modalFilter = ref<SignableListFilters>({
  branches: [],
  users: [],
});

watch(
  () => showModal.value,
  async () => {
    if (!showModal.value) {
      return;
    }

    modalFilter.value.branches = [props.reminderPageFilters.branch];
    modalFilter.value.users = [props.reminderPageFilters.user];
  },
);

const onCancelClick = () => (showModal.value = false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GridFiltersBase, {
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showModal).value = $event)),
    title: __props.modalTitle,
    onClearFilters: onClearFilters,
    onFiltersApplied: onFiltersApplied,
    height: "250px"
  }, {
    filters: _withCtx(() => [
      _createVNode(LookupMultiSelect, {
        title: "Users",
        modelValue: modalFilter.value.users,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modalFilter.value.users) = $event)),
        "lookup-source": _unref(LookupTableSource).Users
      }, null, 8, ["modelValue", "lookup-source"]),
      _createVNode(LookupMultiSelect, {
        title: "Branches",
        modelValue: modalFilter.value.branches,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modalFilter.value.branches) = $event)),
        "lookup-source": _unref(LookupTableSource).Sites
      }, null, 8, ["modelValue", "lookup-source"])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Cancel',
          onClick: () => {
            onCancelClick();
          },
        }
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})